














import { Vue, Component, Prop } from 'vue-property-decorator';
import { restrictedThemes } from '@/app/shared/utils'

@Component
export default class ProgressCircleComponent extends Vue {
  @Prop({default: 0})
  public percent: number;

  @Prop({
    default: null
  })
  public index: number|null;

  @Prop({
    default: 'white'
  })
  public schema: 'white'|'green'|'black';

  @Prop({
    default: 'with-offset'
  })
  public containerClass: 'with-offset'|'without-offset';

  public get customMargin(): boolean {
    return restrictedThemes(['bm'])
  }

  public get showChapter(): boolean {
    return !restrictedThemes(['nistify', 'mekh', 'eucom'])
  }
}
